import { CommonEntrypoint } from 'entrypoint/CommonEntrypoint';
import { DocumentEnquiryProvider } from 'presentation/store/DocumentEnquiry/DocumentEnquiryProvider';
import 'presentation/style/chargeDataEnquiry/chargeDataSearch.scss';
import 'presentation/style/index.scss';
import { DocumentEnquiryContainer } from 'presentation/view/container/DocumentEnquiry/DocumentEnquiryContainer';
import { DocumentEnquiryHeaderContainer } from 'presentation/view/container/DocumentEnquiry/DocumentEnquiryHeaderContainer';

CommonEntrypoint(<DocumentEnquiryContainer />, <DocumentEnquiryHeaderContainer />, DocumentEnquiryProvider)